import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { About } from '../components/About';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { SeoContent } from '../components/SeoContent';
import { ServiceAreas } from '../components/ServiceAreas';
import { CallCta } from '../components/CallCta';
import { usePageMeta } from '../hooks/usePageMeta';
export function AboutPage() {
  usePageMeta({
    title: "About Mike's Pro Detail | Owner-Operated Mobile Detailing",
    description: "Mike's Pro Detail is an owner-operated, fully mobile car detailing service rated 5 stars on Google and Yelp, serving Camarillo, Ventura, Thousand Oaks and all of Ventura County.",
    path: '/about',
    breadcrumbName: 'About'
  });
  return <main data-id="element-600" data-mp="3df3k5b315g38">
      <PageHeader breadcrumb="About" title="About Mike's Pro Detail" subtitle="A premium, fully mobile, owner-operated auto detailing service proudly serving Ventura County." data-id="element-601" data-mp="3dfllun8gomij" />
      <About data-id="element-602" data-mp="1bmnoce3qp5r9" />
      <WhyChooseUs showAboutLink={false} data-id="element-603" data-mp="1bjt1kfx978uo" />
      <SeoContent data-id="element-604" data-mp="2evy1ksrgumd9" />
      <ServiceAreas data-id="element-605" data-mp="2evfvz5iwyvso" />
      <CallCta data-id="element-606" data-mp="2euwetr138bfp" />
    </main>;
}